import React from "react";
import './ContestIndex.css';
import ContestMenu from "./ContestMenu";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import QueryCurrentContestTag from "./QueryCurrentContestTag/QueryCurrentContestTag";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

function GatsbyAllContestNewbieCurrent (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['','ElementMenuActive','','','','']} Active={1}>
            <main className="ContestNewbieReg">
                    <div className="ContestNewbieRegTitle"><TextSource ArrIndex= 'ContestNewbieCurrent0010'>Newbie - Весь список трейдеров</TextSource> </div>
                <div className="ContestNewbieCurrentGrid">
                    <QueryCurrentContestTag lang={props.lang}/>
                    <ContestMenu lang={props.lang} data={props.data} MenuElements={['ActiveElements','NoActiveElements','NoActiveElements']}/>
                </div>
            </main>
        </LayoutMain>
    )}

export default GatsbyAllContestNewbieCurrent